import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';
import SenderEmails from './SenderEmails';
import { useFetchData } from 'services/api/useFetchData';
import { useAuthContext } from 'services/authentication/AuthenticationContext';
import { useSettings } from 'services/settings/SettingsContext';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';
import EmailDomeinList from './EmailDomainList';

const EmailSettings: React.FC = () => {
    const { activeFeatures, environmentHash } = useAuthContext();
    const { environmentSettings } = useSettings();
    const { selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const shouldFetchDivisions = activeFeatures.length > 0 && activeFeatures.includes('divisions');

    // Get the main company details
    const { response: mainCompanyDetails } = useFetchData({ 
        apiUrl: `get_main_company_details/${environmentHash}`,
    });

    // Fetch the divisions when the feature is active
    const { response: fetchedDivisions } = useFetchData({ 
        apiUrl: shouldFetchDivisions ? 'get_division_list' : '',
        useGuard: true,
        guardValue: shouldFetchDivisions
    });

    // Set the fetched divisions or fall back
    const allDivisions = activeFeatures.includes('divisions') ? fetchedDivisions?.results || [] : [];

    // Only show the selected division when another division is selected in the settings menu
    const divisions = !isEnvironmentSelected && selectedDivision
        ? allDivisions.filter((division: { id: number }) => division.id === selectedDivision.id)
        : allDivisions;

    // Show loader when fetching
    if (!mainCompanyDetails || (shouldFetchDivisions && !fetchedDivisions)) {
        return (
            <div className='inline-form-loader'>
                <div className="loader"></div>
            </div>
        )
    }

    // Render settings
    const settings: SettingsSettingType[] = [
        {
            // title: 'email.email_domain.custom_domain_title',
            title: 'email.email_domain.sender_domain_title',
            explanationText: "email.email_domain.custom_domain_description",
            fields: [
                {
                    type: 'tabs',
                    name: 'email_domain_method',
                    buttonSize: 'large',
                    options: [
                        { value: 'default', name: 'email.email_domain.method.default' },
                        { value: 'custom', name: 'email.email_domain.method.custom', 
                            // requiredFeature: 'custom_domain' 
                        },
                    ]
                }
            ]
        },
        {
            title: '',
            scope: 'division',
            fields: [
                {
                    type: 'render',
                    render: () => (
                        <SenderEmails
                            companyName={mainCompanyDetails?.name}
                            divisions={divisions}
                            emailDomainMethod={environmentSettings.email_domain_method as 'default' | 'custom'}
                        />
                    )
                }
            ]
        },
    ];

    return (
        <>
            <SettingsContainer settings={settings} />

            {environmentSettings.email_domain_method === 'custom' && (
                <EmailDomeinList />
            )}
        </>
    );
};

export default EmailSettings;